import React from 'react';
import { useI18n, useLogger } from '~Hooks';
import HandyPageWrapper from '~Scenes/Handy/Components/HandyPageWrapper';
import HandySettingsBlock, {
  SettingBlockItemType,
} from '~Scenes/Handy/Components/HandySettingsBlock';
import { StorageData, useStorage } from '~Components/Storage';

const HandyTablesSettings = () => {
  const { i18n } = useI18n();
  const [storage, commitToStorage] = useStorage();
  const logger = useLogger('handy-settings-tables');

  const updateStorage = (data: Partial<StorageData>) => {
    logger.info('Updating Tables Settings from Handy', { fields: data });
    commitToStorage(data);
  };

  const items: SettingBlockItemType[] = [
    {
      id: 'hide-coverage-modal',
      title: i18n('Settings.HideCoverageModal.Title'),
      description: i18n('Settings.HideCoverageModal.Description'),
      action: {
        onClick: () => updateStorage({ hideCoverageModal: !storage.hideCoverageModal }),
        isToggle: true,
        selected: storage.hideCoverageModal,
      },
    },
    {
      id: 'show-seating-time-in-tsr',
      title: i18n('Settings.Tables.ShowSeatingTime'),
      action: {
        onClick: () => updateStorage({ showSeatingTimeInTSR: !storage.showSeatingTimeInTSR }),
        isToggle: true,
        selected: storage.showSeatingTimeInTSR,
      },
    },
  ];

  return (
    <HandyPageWrapper pageTitle={i18n('Settings.Tables')}>
      <HandySettingsBlock items={items} />
    </HandyPageWrapper>
  );
};

export default HandyTablesSettings;
